<template functional>
  <rate-types-info :rates="props.row.rate_types" class="py-3" />
</template>
<script>
export default {
  name: 'RatesFormatter',
};
</script>
